import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SanitizedDiv } from '@rapid-platform/sanitize-html';
import './description.scss';
function Description(props) {
    return (_jsxs("div", { className: "description flex-column", children: [_jsx("header", { className: "description__header", children: _jsx("h4", { className: "h4 description__header-text", children: "Description" }) }), _jsx("main", { className: "description__container flex-column flex-fill", children: _jsx(SanitizedDiv, { html: props.description ?? '' }) })] }));
}
export default Description;
